import React from 'react'
import { useResume } from './ResumeProvider'
import { useTemplate } from '~/lib/pdf'
import { useTranslation } from '~/hooks/useTranslation'

const TEMPLATE_BANNERS = [
  'ATS-Friendly CV',
  '',
  'ATS-Friendly CV',
  '',
  '',
  'ATS-Friendly CV',
]

const SelectTemplatePanel = () => {
  const { templates } = useTemplate()
  const { locale } = useResume()
  // Swap index 0 and 2 for en_gb locale
  let previewOrder = templates.map((_, idx) => idx)
  if (locale === 'en_gb' && previewOrder.length > 2) {
    ;[previewOrder[0], previewOrder[2]] = [previewOrder[2], previewOrder[0]]
  }

  return (
    <div className="h-full ">
      <div className="grid gap-y-4 sm:grid-cols-2 lg:grid-cols-3">
        {previewOrder.map((templateIdx, displayIdx) => (
          <TemplateOption
            index={templateIdx}
            key={`template-${templateIdx}`}
            displayIdx={displayIdx}
            bannerText={TEMPLATE_BANNERS[templateIdx]}
          />
        ))}
      </div>
    </div>
  )
}
export default SelectTemplatePanel

const TemplateOption = ({ index, bannerText }) => {
  const { t } = useTranslation()
  const { previewTemplateIndex, setPreviewTemplateIndex, locale } = useResume()
  const activeClasses = 'font-roboto-slab text-primary font-bold'
  const inactiveClasses = 'font-roboto-slab text-primary'

  const isPreviewing = previewTemplateIndex === index

  // For en_gb locale, swap the displayed numbers for template 0 and 2
  let num
  if (locale === 'en_gb') {
    if (index === 0) num = 3
    else if (index === 2) num = 1
    else num = index + 1
  } else {
    num = index + 1
  }

  return (
    <div className="flex flex-col items-center">
      <span className={isPreviewing ? activeClasses : inactiveClasses}>
        {t('style_num', { num })}
      </span>
      <button
        onClick={() => setPreviewTemplateIndex(index)}
        className={
          isPreviewing
            ? 'relative rounded-xl border-4 border-solid border-primary'
            : 'group relative m-1 rounded-xl'
        }
      >
        {bannerText && locale === 'en_gb' && (
          <div className="pointer-events-none absolute left-0 top-1/2 z-10 w-full -translate-y-1/2 select-none rounded-none bg-[#046DC5] px-3 py-3 text-center font-inter text-[14px] font-bold leading-[100%] text-white shadow">
            {bannerText}
          </div>
        )}
        <TemplatePreview className="w-48 rounded-xl" templateIndex={index} />
      </button>
    </div>
  )
}

export const TemplatePreview = ({ className, templateIndex }) => {
  const { t } = useTranslation()
  const { locale } = useResume()
  const localizedPath = locale == 'en' ? '' : `/${locale}`

  const url = `https://www-yns-com.s3.amazonaws.com/resume_builder${localizedPath}/Template${templateIndex}.png`

  return (
    <img
      className={className}
      src={url}
      alt={t('template_num', { num: templateIndex })}
    />
  )
}
